module.exports = __webpack_public_path__ + "media/images/faq/brand3-ea55a1f166056572cb4a040c56230450.png";